import { createRoute } from '@/utils/routing'

export const DEPOSITS_VIEW_ROUTE = 'deposits-depositId'
export const DEPOSITS_SETUP_ROUTE = 'savings-setup-index-deposits'

export function createDepositsViewRoute (depositId, options = {}) {
  if (depositId != null) {
    return createRoute(DEPOSITS_VIEW_ROUTE, {
      params: { ...options.params, depositId },
      query: options.query
    })
  }
}

export function createDepositsSetupRoute (options = {}) {
  return createRoute(DEPOSITS_SETUP_ROUTE, options)
}
